// Kurye Takip ekranı kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'couriers.tracking';

export const courierTrackingGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Kurye Takip nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Kuryelerin teslim aldığı ve teslim ettiği siparişleri bu ekranda izlersiniz: kim aldı, ne zaman teslim etti, ne kadar sürdü ve müşterinin konumu nerede. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Geri, Yenile, Haritada Göster'),
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Arama, Durum, Kurye, Tarih'),
    table: t(`${G}.regions.table`, 'Kurye Aktiviteleri'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Özet kartlarını okuyun'),
      text: t(`${G}.s1.text`, 'Üstteki kartlar Aktif Kurye, Devam Eden Teslimat (kuryede olan siparişler), Bugün Teslim Edilen ve Ortalama Teslimat Süresi (dakika) değerlerini gösterir.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Siparişi bulun'),
      text: t(`${G}.s2.text`, 'Arama kutusuna kurye adı, sipariş numarası veya müşteri adı yazın. Durum (Kuryede, Teslim Edildi, İptal Edildi), Kurye ve Tarih (Bugün, Dün, Bu Hafta, Bu Ay) seçimleriyle listeyi daraltın. Sağda kaç sonuç bulunduğu yazar.'),
      tips: [
        t(`${G}.s2.tip1`, '"Bu Hafta" son 7 günü, "Bu Ay" son bir ayı kapsar.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Teslimat listesini okuyun'),
      text: t(`${G}.s3.text`, 'Her satırda Sipariş No, Müşteri, Durum, Teslim Alan ve Teslim Eden Kurye, Teslim Alma ve Teslim Etme Zamanı, Teslimat Süresi, Tutar ve Teslimat Adresi görünür. Mobilde aynı bilgiler kart olarak gösterilir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Müşteri konumunu görün'),
      text: t(`${G}.s4.text`, 'Konum sütununda simge varsa tıklayın: müşterinin siparişte bildirdiği teslimat konumu harita penceresinde açılır. Simge yoksa siparişte konum bilgisi yoktur.'),
    },
    {
      region: 'header',
      title: t(`${G}.s5.title`, '5. Yenileyin, geri dönün'),
      text: t(`${G}.s5.text`, '"Yenile" sayfayı yeniden yükleyerek en güncel siparişleri getirir. "Haritada Göster" Kurye Konumları penceresini açar. Sol üstteki geri oku Kurye Yönetimi sayfasına döner.'),
    },
  ],
});
